<template>
  <div>
    <div class="page-wrapper">
      <div class="page-content-wrapper">
        <div class="shadow-btm">
          <div class="row">
            <div class="col-lg-12 my-auto d-flex align-items-center mb-4">
              <a class="pr-2 text-dark cursor-pointer" @click="$router.push('/segments')">
                <img src="/images/back-arrow.svg" width="18" />
              </a>
              <h4 class="mb-0 lg-bld">{{ id ? "Edit" : "Add" }} Segment</h4>
            </div>
          </div>
        </div>

        <div class="page-content">
          <div class="card-body py-0 px-0">
            <div class="card border mb-0 radius-15">
              <div class="card-body">
                <Form @submit="save">
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label>Segment Name</label>
                        <span class="text-danger">*</span>
                        <Field
                          type="text"
                          name="segment_name"
                          class="form-control"
                          placeholder="Segment Name"
                          v-model="detail.name"
                          rules="required:Segment Name"
                          :validateOnInput="true"
                        />
                        <ErrorMessage name="segment_name" class="text-danger" />
                      </div>
                    </div>

                    <div class="col-lg-12 text-center mt-2">
                      <button id="save-button" type="submit" class="save-btn px-4 ml-3">Save</button>
                      <button type="button" class="fil-btn px-4 ml-3" @click="$router.go(-1)">Cancel</button>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ErrorComponent @retry="getDetail" ref="errorComponent" />
  </div>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import ErrorComponent from "@/components/ErrorComponent";

export default {
  name: "AddEditSegment",
  components: { Form, Field, ErrorMessage, ErrorComponent },
  data() {
    return {
      id: this.$route.params.id,
      detail: {},
    };
  },
  mounted() {
    if (this.id) this.getDetail();
  },
  methods: {
    getDetail() {
      this.$refs.errorComponent.updateFormLoader(true);
      this.$api
        .getAPI({ _action: "/segments/detail/" + this.id })
        .then((res) => {
          this.detail = res;
          this.$refs.errorComponent.updateFormLoader(false);
        })
        .catch(() => {
          this.$refs.errorComponent.updateFormLoader(false);
        });
    },
    save() {
      const apiCall = this.id
        ? this.$api.putAPI({
            _action: "/segments/edit/" + this.id,
            _body: this.detail,
            _buttonId: "save-button",
          })
        : this.$api.postAPI({
            _action: "/segments/add",
            _body: this.detail,
            _buttonId: "save-button",
          });

      apiCall.then((res) => {
        this.$router.go(-1);
        this.$notify({ type: "success", text: res.message });
      });
    },
  },
};
</script>
